import { InvoiceCreationSummary } from '@iota/iota-management-portal-v4-client';
import { createAction, props } from '@ngrx/store';
import { InvoiceCreationProcessData } from 'src/app/shared/constants-and-enums/invoice-creation-process-types';

export const InitInvoiceCreationForm = createAction('[InvoiceCreationProcess] InitInvoiceCreationForm');
export const ResetInvoiceCreationForm = createAction('[InvoiceCreationProcess] ResetInvoiceCreationForm');
export const InvoiceCreationProcessUpsertForm = createAction(
    '[InvoiceCreationProcess] InvoiceCreationProcessUpsertForm',
    props<{ data: InvoiceCreationProcessData }>()
);

export const StartInvoiceCreationProcess = createAction('[InvoiceCreationProcess] StartInvoiceCreationProcess');
export const InvoiceCreationProcessSuccess = createAction(
    '[InvoiceCreationProcess] InvoiceCreationProcessSuccess',
    props<{ result: InvoiceCreationSummary }>()
);
export const InvoiceCreationProcessFailure = createAction(
    '[InvoiceCreationProcess] InvoiceCreationProcessFailure',
    props<{ error?: any }>()
);
